import { Box, Card, CardContent, Skeleton } from '@mui/material';

export function CommentSkeleton() {
  return (
    <Card variant="outlined" sx={{ bgcolor: 'action.hover' }}>
      <CardContent sx={{ py: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="rectangular" width={50} height={20} sx={{ borderRadius: 1 }} />
          <Skeleton variant="text" width={60} height={20} />
        </Box>
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="80%" height={20} />
      </CardContent>
    </Card>
  );
}

export default CommentSkeleton;
